var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.handleClick}},[_c('icon-svg',{attrs:{"name":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }